import { chakra } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import useApiQuery from 'lib/api/useApiQuery';
import dayjs from 'lib/date/dayjs';
import { Link } from 'toolkit/chakra/link';
import { Skeleton } from 'toolkit/chakra/skeleton';

import GasInfoTooltip from './GasInfoTooltip';
import GasPrice from './GasPrice';

export const GasPriceInfo = () => {

  const { data, isPlaceholderData, isError, refetch, dataUpdatedAt } = useApiQuery('general:stats', {
    queryOptions: {
      refetchOnMount: false,
    },
  });

  React.useEffect(() => {
    if (isPlaceholderData || !data?.gas_price_updated_at) {
      return;
    }

    const endDate = dayjs(dataUpdatedAt).add(data.gas_prices_update_in, 'ms');
    const timeout = endDate.diff(dayjs(), 'ms');

    if (timeout <= 0) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      refetch();
    }, timeout);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [ isPlaceholderData, data?.gas_price_updated_at, dataUpdatedAt, data?.gas_prices_update_in, refetch ]);

  if (isError) {
    return <div/>;
  }

  return (
    data?.gas_prices && data.gas_prices.average !== null && config.features.gasTracker.isEnabled && (
      <Skeleton textStyle="sm" loading={ isPlaceholderData } display="inline-flex" whiteSpace="pre-wrap">
        <chakra.span color="text.secondary">Gas </chakra.span>
        <GasInfoTooltip data={ data } dataUpdatedAt={ dataUpdatedAt } placement={ !data?.coin_price ? 'bottom-start' : undefined }>
          <Link>
            <GasPrice data={ data.gas_prices.average }/>
          </Link>
        </GasInfoTooltip>
      </Skeleton>
    )
  );
};
